const detachments = [
  // 40k Detachments
  // { gameType: 1, faction: "Adepta Sororitas", detachment: "Hallowed Martyrs" },
  // { gameType: 1, faction: "Adepta Sororitas", detachment: "Penitent Host" },
  // { gameType: 1, faction: "Adepta Sororitas", detachment: "Bringers of Flame" },
  // { gameType: 1, faction: "Adepta Sororitas", detachment: "Army of Faith" },
  // {
  //   gameType: 1,
  //   faction: "Adepta Sororitas",
  //   detachment: "Champions of Faith"
  // },
  // { gameType: 1, faction: "Adeptus Custodes", detachment: "Shield Host" },
  // {
  //   gameType: 1,
  //   faction: "Adeptus Custodes",
  //   detachment: "Talons of the Emperor"
  // },
  // { gameType: 1, faction: "Adeptus Custodes", detachment: "Null Maiden Vigil" },
  // { gameType: 1, faction: "Adeptus Custodes", detachment: "Auric Champions" },
  // { gameType: 1, faction: "Adeptus Custodes", detachment: "Solar Spearhead" },
  // { gameType: 1, faction: "Adeptus Mechanicus", detachment: "Rad-Zone Corps" },
  // {
  //   gameType: 1,
  //   faction: "Adeptus Mechanicus",
  //   detachment: "Skitarii Hunter Cohort"
  // },
  // {
  //   gameType: 1,
  //   faction: "Adeptus Mechanicus",
  //   detachment: "Data Psalm Conclave"
  // },
  // {
  //   gameType: 1,
  //   faction: "Adeptus Mechanicus",
  //   detachment: "Explorator Maniple"
  // },
  // {
  //   gameType: 1,
  //   faction: "Adeptus Mechanicus",
  //   detachment: "Cohort Cybernetica"
  // },
  // {
  //   gameType: 1,
  //   faction: "Adeptus Mechanicus",
  //   detachment: "Haloscreed Battle Clade"
  // },
  // { gameType: 1, faction: "Aeldari", detachment: "Battle Host" },
  // { gameType: 1, faction: "Aeldari", detachment: "Armored Warhost" },
  // { gameType: 1, faction: "Astra Militarum", detachment: "Combined Regiment" },
  // { gameType: 1, faction: "Astra Militarum", detachment: "Bridgehead Strike" },
  // { gameType: 1, faction: "Black Templars", detachment: "Righteous Crusaders" },
  // { gameType: 1, faction: "Black Templars", detachment: "Wrathful Procession" },
  // {
  //   gameType: 1,
  //   faction: "Blood Angels",
  //   detachment: "Liberator Assault Group"
  // },
  // { gameType: 1, faction: "Blood Angels", detachment: "The Lost Brethren" },
  // { gameType: 1, faction: "Blood Angels", detachment: "The Angelic Host" },
  // { gameType: 1, faction: "Blood Angels", detachment: "Angelic Inheritors" },
  // { gameType: 1, faction: "Chaos Daemons", detachment: "Daemonic Incursion" },
  // { gameType: 1, faction: "Chaos Daemons", detachment: "Plague Legion" },
  // { gameType: 1, faction: "Chaos Daemons", detachment: "Scintillating Legion" },
  // { gameType: 1, faction: "Chaos Daemons", detachment: "Blood Legion" },
  // { gameType: 1, faction: "Chaos Daemons", detachment: "Legion of Excess" },
  // { gameType: 1, faction: "Chaos Knights", detachment: "Traitoris Lance" },
  // { gameType: 1, faction: "Chaos Knights", detachment: "Iconoclast Fiefdom" },
  // {
  //   gameType: 1,
  //   faction: "Chaos Space Marines",
  //   detachment: "Veterans of the Long War"
  // },
  // { gameType: 1, faction: "Chaos Space Marines", detachment: "Deceptors" },
  // {
  //   gameType: 1,
  //   faction: "Chaos Space Marines",
  //   detachment: "Renegade Raiders"
  // },
  // { gameType: 1, faction: "Chaos Space Marines", detachment: "Dread Talons" },
  // {
  //   gameType: 1,
  //   faction: "Chaos Space Marines",
  //   detachment: "Fellhammer Siege-Host"
  // },
  // {
  //   gameType: 1,
  //   faction: "Chaos Space Marines",
  //   detachment: "Pactbound Zealots"
  // },
  // { gameType: 1, faction: "Chaos Space Marines", detachment: "Chaos Cult" },
  // {
  //   gameType: 1,
  //   faction: "Chaos Space Marines",
  //   detachment: "Soulforged Warpack"
  // },
  // {
  //   gameType: 1,
  //   faction: "Chaos Space Marines",
  //   detachment: "Creations of Bile"
  // },
  // { gameType: 1, faction: "Dark Angels", detachment: "Unforgiven Task Force" },
  // { gameType: 1, faction: "Dark Angels", detachment: "Inner Circle" },
  // { gameType: 1, faction: "Dark Angels", detachment: "Company of Hunters" },
  // {
  //   gameType: 1,
  //   faction: "Dark Angels",
  //   detachment: "Lion's Blade Task Force"
  // },
  // { gameType: 1, faction: "Death Guard", detachment: "Plague Company" },
  // { gameType: 1, faction: "Death Guard", detachment: "Flyblown Host" },
  // { gameType: 1, faction: "Deathwatch", detachment: "Black Spear Task Force" },
  // { gameType: 1, faction: "Drukhari", detachment: "Realspace Raiders" },
  // { gameType: 1, faction: "Drukhari", detachment: "Reaper's Wager" },
  // {
  //   gameType: 1,
  //   faction: "Genestealer Cults",
  //   detachment: "Host of Ascension"
  // },
  // { gameType: 1, faction: "Genestealer Cults", detachment: "Final Day" },
  // { gameType: 1, faction: "Grey Knights", detachment: "Teleport Strike Force" },
  // { gameType: 1, faction: "Grey Knights", detachment: "Warpbane Task Force" },
  // {
  //   gameType: 1,
  //   faction: "Imperial Agents",
  //   detachment: "Ordo Xenos Alien Hunters"
  // },
  // {
  //   gameType: 1,
  //   faction: "Imperial Agents",
  //   detachment: "Ordo Hereticus Purgation Force"
  // },
  // { gameType: 1, faction: "Imperial Agents", detachment: "Ordo Malleus" },
  // { gameType: 1, faction: "Imperial Agents", detachment: "Imperialis Fleet" },
  // {
  //   gameType: 1,
  //   faction: "Imperial Agents",
  //   detachment: "Veiled Blade Elimination Force"
  // },
  // { gameType: 1, faction: "Imperial Knights", detachment: "Noble Lance" },
  // { gameType: 1, faction: "Imperial Knights", detachment: "Questor Forgepact" },
  // { gameType: 1, faction: "Leagues of Votann", detachment: "Oathband" },
  // { gameType: 1, faction: "Leagues of Votann", detachment: "Hearthband" },
  // { gameType: 1, faction: "Orks", detachment: "War Horde" },
  // { gameType: 1, faction: "Orks", detachment: "Da Big Hunt" },
  // { gameType: 1, faction: "Orks", detachment: "Kult of Speed" },
  // { gameType: 1, faction: "Orks", detachment: "Dread Mob" },
  // { gameType: 1, faction: "Orks", detachment: "Green Tide" },
  // { gameType: 1, faction: "Orks", detachment: "Bully Boyz" },
  // { gameType: 1, faction: "Orks", detachment: "Taktikal Brigade" },
  // { gameType: 1, faction: "Necrons", detachment: "Awakened Dynasty" },
  // { gameType: 1, faction: "Necrons", detachment: "Annihilation Legion" },
  // { gameType: 1, faction: "Necrons", detachment: "Canoptek Court" },
  // { gameType: 1, faction: "Necrons", detachment: "Obeisance Phalanx" },
  // { gameType: 1, faction: "Necrons", detachment: "Hypercrypt Legion" },
  // { gameType: 1, faction: "Necrons", detachment: "Starshatter Arsenal" },
  // { gameType: 1, faction: "Space Marines", detachment: "Gladius Task Force" },
  // {
  //   gameType: 1,
  //   faction: "Space Marines",
  //   detachment: "1st Company Task Force"
  // },
  // { gameType: 1, faction: "Space Marines", detachment: "Vanguard Spearhead" },
  // {
  //   gameType: 1,
  //   faction: "Space Marines",
  //   detachment: "Stormlance Task Force"
  // },
  // {
  //   gameType: 1,
  //   faction: "Space Marines",
  //   detachment: "Firestorm Assault Force"
  // },
  // { gameType: 1, faction: "Space Marines", detachment: "Ironstorm Spearhead" },
  // { gameType: 1, faction: "Space Marines", detachment: "Anvil Siege Force" },
  // { gameType: 1, faction: "Space Marines", detachment: "Librarius Conclave" },
  // { gameType: 1, faction: "Space Wolves", detachment: "Champions of Russ" },
  // { gameType: 1, faction: "Space Wolves", detachment: "Champions of Fenris" },
  // { gameType: 1, faction: "T'au Empire", detachment: "Kauyon" },
  // { gameType: 1, faction: "T'au Empire", detachment: "Mont'ka" },
  // { gameType: 1, faction: "T'au Empire", detachment: "Retaliation Cadre" },
  // { gameType: 1, faction: "T'au Empire", detachment: "Kroot Hunting Pack" },
  // { gameType: 1, faction: "T'au Empire", detachment: "Auxiliary Cadre" },
  // { gameType: 1, faction: "Thousand Sons", detachment: "Cult of Magic" },
  // { gameType: 1, faction: "Thousand Sons", detachment: "Hexwarp Thrallband" },
  // { gameType: 1, faction: "Tyranids", detachment: "Invasion Fleet" },
  // { gameType: 1, faction: "Tyranids", detachment: "Vanguard Onslaught" },
  // { gameType: 1, faction: "Tyranids", detachment: "Crusher Stampede" },
  // { gameType: 1, faction: "Tyranids", detachment: "Assimilation Swarm" },
  // { gameType: 1, faction: "Tyranids", detachment: "Synaptic Nexus" },
  // { gameType: 1, faction: "Tyranids", detachment: "Unending Swarm" },
  // { gameType: 1, faction: "Tyranids", detachment: "Warrior Bioform Onslaught" },
  // { gameType: 1, faction: "World Eaters", detachment: "Berzerker Warband" },
  // { gameType: 1, faction: "World Eaters", detachment: "World Eaters" }
  // Age of Sigmar Detachments
  // {
  //   gameType: 4,
  //   faction: "Cities of Sigmar",
  //   detachment: "Dawnbringer Crusade"
  // },
  // {
  //   gameType: 4,
  //   faction: "Cities of Sigmar",
  //   detachment: "Fortress-city Defenders"
  // },
  // {
  //   gameType: 4,
  //   faction: "Cities of Sigmar",
  //   detachment: "Ironweld Guild Army"
  // },
  // {
  //   gameType: 4,
  //   faction: "Cities of Sigmar",
  //   detachment: "Collegiate Arcane Expedition"
  // },
  // {
  //   gameType: 4,
  //   faction: "Cities of Sigmar",
  //   detachment: "Veteran Cannoneers"
  // },
  // {
  //   gameType: 4,
  //   faction: "Cities of Sigmar",
  //   detachment: "Fearless Exemplars"
  // },
  // {
  //   gameType: 4,
  //   faction: "Stormcast Eternals",
  //   detachment: "Sentinels of the Bleak Citadels"
  // },
  // { gameType: 4, faction: "Stormcast Eternals", detachment: "Vanguard Wing" },
  // {
  //   gameType: 4,
  //   faction: "Stormcast Eternals",
  //   detachment: "Thunderhead Host"
  // },
  // {
  //   gameType: 4,
  //   faction: "Stormcast Eternals",
  //   detachment: "Lightning Echelon"
  // },
  // {
  //   gameType: 4,
  //   faction: "Stormcast Eternals",
  //   detachment: "Sacrosanct Convocation"
  // },
  // { gameType: 4, faction: "Ironjawz", detachment: "Ironjawz Brawl" },
  // { gameType: 4, faction: "Ironjawz", detachment: "Weirdfist" },
  // { gameType: 4, faction: "Ironjawz", detachment: "Ironfist" },
  // { gameType: 4, faction: "Ironjawz", detachment: "Grunta Stampede" },
  // { gameType: 4, faction: "Ironjawz", detachment: "Brutefist" },
  // { gameType: 4, faction: "Ironjawz", detachment: "Bigsnikkaz" },
  // { gameType: 4, faction: "Skaven", detachment: "Virulent Procession" },
  // { gameType: 4, faction: "Skaven", detachment: "Fleshmeld Menagerie" },
  // { gameType: 4, faction: "Skaven", detachment: "Claw-horde" },
  // { gameType: 4, faction: "Skaven", detachment: "Warpcog Convocation" },
  // { gameType: 4, faction: "Slaves to Darkness", detachment: "Legion of Chaos" },
  // { gameType: 4, faction: "Slaves to Darkness", detachment: "Despoilers" },
  // {
  //   gameType: 4,
  //   faction: "Slaves to Darkness",
  //   detachment: "Godswarth Warband"
  // },
  // { gameType: 4, faction: "Slaves to Darkness", detachment: "Darkoath Horde" },
  // { gameType: 4, faction: "Slaves to Darkness", detachment: "Chaos Horde" },
  // {
  //   gameType: 4,
  //   faction: "Slaves to Darkness",
  //   detachment: "Champions of Chaos"
  // },
  // { gameType: 4, faction: "Nighthaunt", detachment: "Quicksilver Gheists" },
  // { gameType: 4, faction: "Nighthaunt", detachment: "Shrieker Host" },
  // { gameType: 4, faction: "Nighthaunt", detachment: "Death Stalkers" },
  // { gameType: 4, faction: "Nighthaunt", detachment: "Royal Procession" },
  // { gameType: 4, faction: "Nighthaunt", detachment: "Hungry Nexus" },
  // { gameType: 4, faction: "Nighthaunt", detachment: "Deathrust Gheists" },
  // {
  //   gameType: 4,
  //   faction: "Flesh-eater Courts",
  //   detachment: "Knightly Echelon"
  // },
  // { gameType: 4, faction: "Flesh-eater Courts", detachment: "The Royal Hunt" },
  // {
  //   gameType: 4,
  //   faction: "Flesh-eater Courts",
  //   detachment: "Lords of the Manor"
  // },
  // { gameType: 4, faction: "Flesh-eater Courts", detachment: "Royal Menagerie" },
  // {
  //   gameType: 4,
  //   faction: "Flesh-eater Courts",
  //   detachment: "Impassioned Serfs"
  // },
  // {
  //   gameType: 4,
  //   faction: "Flesh-eater Courts",
  //   detachment: "Questing Courtiers"
  // }
];
export function getDetachments(gameType, faction, army) {
  let _detachments = detachments.filter(
    (el) =>
      el.gameType === gameType &&
      (el.faction.toUpperCase() === faction?.name?.toUpperCase() ||
        el.faction.toUpperCase() === army?.name?.toUpperCase())
  );

  _detachments.sort((a, b) => {
    var nameA = a.detachment.toLowerCase();
    var nameB = b.detachment.toLowerCase();
    if (nameA > nameB) return 1;
    if (nameA < nameB) return -1;
    return 0;
  });
  return _detachments;
}
